import i18next from 'i18next';

i18next.addResources('es', 'contentType', {
  // TODO: review this types with backend
  event: 'Evento',
  publication: 'Publicación',
  project: 'Proyecto',
  energy: 'Energía',
  transport: 'Transporte y logística',
  boundary: 'Fronteras',
  telecommunications: 'Telecomunicaciones',
  article: 'Artículo',
  workshop: 'Taller',
  infographic: 'Infografía',
  news: 'Noticias',
  publishing: 'Publicación',
  video: 'Video',
  hackathon: 'Hackaton',
  meeting: 'Webinar',
  conference: 'Conferencia',
  training: 'Capacitación',
  seminar: 'Seminario'
});

i18next.addResources('en', 'contentType', {
  // TODO: review this types with backend
  event: 'Event',
  publication: 'Publication',
  project: 'Project',
  energy: 'Energy',
  transport: 'Transport and Logistics',
  boundary: 'Borders',
  telecommunications: 'Telecommunications',
  article: 'Article',
  workshop: 'Workshop',
  infographic: 'Infographic',
  news: 'News',
  publishing: 'Publication',
  video: 'Video',
  hackathon: 'Hackathon',
  meeting: 'Webinar',
  conference: 'Conference',
  training: 'Training',
  seminar: 'Seminar'
});

i18next.addResources('pt', 'contentType', {
  // TODO: review this types with backend
  event: 'Evento',
  publication: 'Publicação',
  project: 'Projeto',
  energy: 'Energia',
  transport: 'Transporte e Logística',
  boundary: 'Fronteiras',
  telecommunications: 'Telecomunicações',
  article: 'Artigo',
  workshop: 'Oficina',
  infographic: 'Infográfico',
  news: 'Notícias',
  publishing: 'Publicação',
  video: 'Vídeo',
  hackathon: 'Hackathon',
  meeting: 'Webinar',
  conference: 'Conferência',
  training: 'Capacitação',
  seminar: 'Seminário'
});
